import { FiltersDialogComponent } from 'src/app/components/filters/filters-dialog.component';
import { FilterDialogComponentParams } from './../../components/filters/filters-ui.models';
import { Component, OnInit, Input } from '@angular/core';
import { filterPageTypes, FilterType } from 'src/app/store/filters.era';
import { PAGE_NAME } from 'src/app/services/event.permissions.service';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { PageHandle } from 'globals/store/permissions.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { CalendarComponent } from './calendar.component';
@Component({
    selector: 'app-task-calendar-page',
    templateUrl: './task-calendar.page.html',
    styles: [`
  calendar { overflow-y: auto }
`], styleUrls: ['../../page.scss'],
    standalone: true,
    imports: [TopMenuComponent, MobileMenuComponent, LoaderPaneFragmentComponent, CalendarComponent],
})
export class TaskCalendarPageComponent extends Wrapper<TaskCalendarPageComponent> implements OnInit {

  readonly _file = 'task-calendar.page.ts';
  actualFilterCount
  @Input() filterPage: FilterType = filterPageTypes.tasksCalendar
  @Input() isMyTasks:boolean;
  @Input() page_name: PageHandle = PAGE_NAME.task_calendar;
  @Input() traceName = traceNames.viewTasksCalendar

  constructor() {
    super()
    this.uiService.changePageTitle("Task Calendar", true);
  }

  ngOnInit() {
    this.subProp(this.store.select('filters', this.filterPage, 'count'), 'actualFilterCount')
  }

  async filter() {
    const filterGroupings = await this.filtersService.buildTaskPageFilterUI(this.filterPage)
    const params: FilterDialogComponentParams = { width: '380px', autoFocus: false, data: { filterPage: this.filterPage, filterGroupings } }
    this.dialog.open(FiltersDialogComponent, params)
  }

}
